<wiz-hgroup height="100%" width="100%" [wizDisabled]="owner.wizDisabled" verticalAlign="center">
  <wiz-label [wizLabel]="getLabel()" width="100%" [wizTextBehavior]="'truncate'"></wiz-label>
  <wiz-hgroup #actionContainer height="100%" verticalAlign="center" horizontalAlign="end" width="55px">
    <!-- On utilise le click pour pouvoir faire un prevent -->
    <wiz-icon [visible]="canAdd()" (click)="doAdd($event)" [wizTooltip]="'$.common.addchild.$'" >add</wiz-icon>
    <wiz-icon [visible]="canDelete()" (click)="doDelete($event)" [wizTooltip]="'$.common.delete.$'" >close</wiz-icon>
    <wiz-spacer *ngIf="!canDelete()" width="16px" height="16px"></wiz-spacer>
  </wiz-hgroup>
</wiz-hgroup>
